<template>
  <v-container fluid>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-row>
        <v-col>
          <parametros-agendamentos-automaticos 
          :agendamentosAtivos="agendamentosAtivos"
          :agendamentosInativos="agendamentosInativos"
          :loading="loading"
          ref="refAgendamentos" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn 
            id="btnSalvarAgendamento"
            color="success" 
            min-width="100" 
            style="float: right" 
            :loading="loading" 
            :disabled="invalid"
            @click="salvarAgendamentos()">
              Salvar
          </v-btn>
        </v-col>
      </v-row>
  </validation-observer>
  </v-container>
</template>
<script>
import AgendamentosAutomaticos from "@/services/AgendamentosAutomaticos.js";

export default {
  components: {
    ParametrosAgendamentosAutomaticos: () => import("@/components/agendamentosAutomaticos/ParametrosAgendamentosAutomaticos.vue"),
  },

  created() {
    this.getAgendamentosAutomaticos() 
  },

  data: () => ({
      agendamentosAtivos: [],
      agendamentosInativos: [],
      loading: false,
      agendamentos: []
  }),

  methods: { 
    getAgendamentosAutomaticos() {
      this.loading = true;

      AgendamentosAutomaticos.getAgendamentosAutomaticos()
        .then(response => {
          this.agendamentosAtivos = response.data.agendamentosAtivos;
          this.agendamentosInativos = response.data.agendamentosInativos;
        })
        .catch(() => {
          this.$toast.error("Erro ao recuperar dados", "", { position: "topRight"});
        })
        .finally(() => this.loading = false);
    },

    salvarAgendamentos() {
      this.loading = true;
      
      this.agendamentos = this.$refs.refAgendamentos.agendamentosAtivos.concat(this.$refs.refAgendamentos.agendamentosInativos)
      this.$refs.refAgendamentos.closePanel();
      
      AgendamentosAutomaticos.salvarItem(this.agendamentos)
        .then(response => {
          this.$toast.success(response.data.msg, "", {position: "topRight"});
        })
        .catch(() => {
          this.$toast.error("Erro ao atualizar os dados", "", { position: "topRight"});
        })
        .finally(() => {
        this.loading = false;
        this.$refs.refAgendamentos.focus()
      })
    }
  }
}
</script>